/* eslint-disable @faire/enforce-internal-folder-encapsulation */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { formatMoney } from "@faire/web--source/common/money";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import { ExpectedShipDate } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ExpectedShipDate";
import { ProductName } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProductName";
import { MaybeProminentPriceFirstSlotter } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProminentPriceFirst/MaybeProminentPriceFirstWrapper";
import { BrandPageProductTileSwatches } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileSwatches";
import { RetailInfoContainer } from "@faire/retailer/features/MarketplaceItems/styled";
import { showProductPromotions } from "@faire/retailer/lib/showProductPromotions";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { Price } from "@faire/retailer/views/product/ProductDetails/Price/Price";
import { PRICE_TEXT_SURFACE } from "@faire/retailer/views/product/ProductDetails/Price/PriceProps";
export var RetailInfo = function(props) {
    var _productTile_quick_add_quick_add_option, _productTile_quick_add, _productTile_quick_add_quick_add_option1, _productTile_quick_add1, _productTile_product, _productTile_min_option_wholesale_promo_price, _productTile_product1;
    var isLoggedIn = props.isLoggedInOrBrandPreview, productTile = props.productTile, isSalesPaused = props.isSalesPaused;
    var limitedStockText = useMemo(function() {
        var _productTile_quick_add_quick_add_option, _productTile_quick_add, _productTile_quick_add_quick_add_option1, _productTile_quick_add1, _productTile_product;
        var _productTile_quick_add_quick_add_option_option_available_units;
        var availableUnits = (_productTile_quick_add_quick_add_option_option_available_units = (_productTile_quick_add = productTile.quick_add) === null || _productTile_quick_add === void 0 ? void 0 : (_productTile_quick_add_quick_add_option = _productTile_quick_add.quick_add_option) === null || _productTile_quick_add_quick_add_option === void 0 ? void 0 : _productTile_quick_add_quick_add_option.option_available_units) !== null && _productTile_quick_add_quick_add_option_option_available_units !== void 0 ? _productTile_quick_add_quick_add_option_option_available_units : Number.POSITIVE_INFINITY;
        var _productTile_quick_add_quick_add_option_option_unit_multiplier;
        var unitMultiplier = (_productTile_quick_add_quick_add_option_option_unit_multiplier = (_productTile_quick_add1 = productTile.quick_add) === null || _productTile_quick_add1 === void 0 ? void 0 : (_productTile_quick_add_quick_add_option1 = _productTile_quick_add1.quick_add_option) === null || _productTile_quick_add_quick_add_option1 === void 0 ? void 0 : _productTile_quick_add_quick_add_option1.option_unit_multiplier) !== null && _productTile_quick_add_quick_add_option_option_unit_multiplier !== void 0 ? _productTile_quick_add_quick_add_option_option_unit_multiplier : 1;
        var comesInCases = unitMultiplier !== 1;
        var availableQuantity = comesInCases ? Math.floor(availableUnits / unitMultiplier) : availableUnits;
        var isLimitedStock = availableQuantity > 0 && availableQuantity <= 3;
        var isSalesPaused = ((_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.state) === IProduct.State.SALES_PAUSED;
        if (!isLimitedStock || isSalesPaused) {
            return null;
        }
        return comesInCases ? /*#__PURE__*/ _jsx(LimitedStock, {
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "aSR7Hu",
                defaultMessage: [
                    {
                        type: 6,
                        value: "availableQuantity",
                        options: {
                            one: {
                                value: [
                                    {
                                        type: 0,
                                        value: "Only "
                                    },
                                    {
                                        type: 7
                                    },
                                    {
                                        type: 0,
                                        value: " case left!"
                                    }
                                ]
                            },
                            other: {
                                value: [
                                    {
                                        type: 0,
                                        value: "Only "
                                    },
                                    {
                                        type: 7
                                    },
                                    {
                                        type: 0,
                                        value: " cases left!"
                                    }
                                ]
                            }
                        },
                        offset: 0,
                        pluralType: "cardinal"
                    }
                ],
                values: DEPRECATED_backwardsCompatibleValues({
                    availableQuantity: availableQuantity
                })
            })
        }) : /*#__PURE__*/ _jsx(LimitedStock, {
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "qHhL47",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Only "
                    },
                    {
                        type: 1,
                        value: "availableQuantity"
                    },
                    {
                        type: 0,
                        value: " left!"
                    }
                ],
                values: DEPRECATED_backwardsCompatibleValues({
                    availableQuantity: availableQuantity
                })
            })
        });
    }, [
        (_productTile_quick_add = productTile.quick_add) === null || _productTile_quick_add === void 0 ? void 0 : (_productTile_quick_add_quick_add_option = _productTile_quick_add.quick_add_option) === null || _productTile_quick_add_quick_add_option === void 0 ? void 0 : _productTile_quick_add_quick_add_option.option_available_units,
        (_productTile_quick_add1 = productTile.quick_add) === null || _productTile_quick_add1 === void 0 ? void 0 : (_productTile_quick_add_quick_add_option1 = _productTile_quick_add1.quick_add_option) === null || _productTile_quick_add_quick_add_option1 === void 0 ? void 0 : _productTile_quick_add_quick_add_option1.option_unit_multiplier,
        (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.state
    ]);
    var eligibleForInventoryText = isLoggedIn && (productTile.case_size_text || limitedStockText || isSalesPaused);
    var productLevelPromotion = productTile === null || productTile === void 0 ? void 0 : productTile.min_option_wholesale_promo_price;
    var originalPrice = (productTile === null || productTile === void 0 ? void 0 : productTile.min_option_wholesale_price) ? formatMoney({
        money: productTile.min_option_wholesale_price,
        omitCentsIfZero: true
    }) : "";
    var wholesalePrice = (productTile === null || productTile === void 0 ? void 0 : (_productTile_min_option_wholesale_promo_price = productTile.min_option_wholesale_promo_price) === null || _productTile_min_option_wholesale_promo_price === void 0 ? void 0 : _productTile_min_option_wholesale_promo_price.discounted_item_price) ? formatMoney({
        money: productTile.min_option_wholesale_promo_price.discounted_item_price,
        omitCentsIfZero: true
    }) : originalPrice;
    var retailPrice = (productTile === null || productTile === void 0 ? void 0 : productTile.min_option_retail_price) ? formatMoney({
        money: productTile.min_option_retail_price,
        omitCentsIfZero: true
    }) : "";
    var isUK = useRetailerStore([
        "isUK"
    ]).isUK;
    var priceComponent = /*#__PURE__*/ _jsx(Price, {
        isUKRetailer: isUK,
        showProductPromotions: showProductPromotions(productLevelPromotion),
        isTilePricing: true,
        small: true,
        isLoggedInOrBrandPreview: isLoggedIn,
        originalPrice: originalPrice,
        wholesalePrice: wholesalePrice,
        retailPrice: retailPrice,
        priceTextSurface: PRICE_TEXT_SURFACE.BRAND
    });
    var _productTile_product_name;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(RetailInfoContainer, {
            children: [
                /*#__PURE__*/ _jsx(MaybeProminentPriceFirstSlotter, {
                    isPriceFirstSlot: true,
                    children: priceComponent
                }),
                /*#__PURE__*/ _jsx(ProductName, {
                    productName: (_productTile_product_name = productTile === null || productTile === void 0 ? void 0 : (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.name) !== null && _productTile_product_name !== void 0 ? _productTile_product_name : ""
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: 4
                }),
                /*#__PURE__*/ _jsx(MaybeProminentPriceFirstSlotter, {
                    isPriceFirstSlot: false,
                    children: priceComponent
                }),
                eligibleForInventoryText ? /*#__PURE__*/ _jsxs(CaseLine, {
                    children: [
                        productTile.case_size_text ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraphSansRegular",
                                    color: Core.text.subdued,
                                    children: productTile.case_size_text
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    width: "1x"
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ _jsx(StockTextContent, {
                            limitedStockText: limitedStockText,
                            isSalesPaused: isSalesPaused
                        })
                    ]
                }) : null,
                productTile && productTile.options_details ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: {
                                mobileAndAbove: 2,
                                tabletAndAbove: 4
                            }
                        }),
                        /*#__PURE__*/ _jsx(BrandPageProductTileSwatches, {
                            productTileInfo: productTile
                        })
                    ]
                }) : null,
                /*#__PURE__*/ _jsx(ExpectedShipDate, {
                    shipDate: productTile.expected_shipping_date
                })
            ]
        })
    });
};
var StockTextContent = function(props) {
    var limitedStockText = props.limitedStockText, isSalesPaused = props.isSalesPaused;
    if (limitedStockText) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: limitedStockText
        });
    } else if (isSalesPaused) {
        return /*#__PURE__*/ _jsx(Typography, {
            variant: "paragraphSansRegular",
            color: Core.text.critical,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "G6G2FK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Out of stock"
                    }
                ]
            })
        });
    } else {
        return null;
    }
};
var LimitedStock = styled(Typography).attrs({
    color: Decorative.shade.orange
}).withConfig({
    componentId: "sc-c1633030-0"
})([
    "width:auto;font-style:italic;"
]);
var CaseLine = styled(Row).attrs({
    align: "baseline"
}).withConfig({
    componentId: "sc-c1633030-1"
})([
    "width:100%;flex-wrap:wrap;"
]);
